import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Hdfcsky: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h2>Hdfcsky API Setup in 5 Steps</h2>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">To start click on this link and login with Hdfcsky credentials</h2>
          <b>
            <a href="https://developer.hdfcsky.com/" target="blank" title="Hdfcsky Developer Login">
              https://developer.hdfcsky.com/
            </a>
          </b>
        </div>
      </li>

      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Go to
            {oneIndentation}
            <b>My Apps.</b>
            {oneIndentation}
            Click on create App
          </h2>
          <img src="/landing-page-img/brokers-img/hdfcsky_step_2.png" alt="API Apps page" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">Fill below details and create.</h2>
          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>App Name:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" id="" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="Quantman" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Redirect URL:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input
                    type="text"
                    placeholder="https://www.quantman.trade/auth/hdfcsky/callback"
                    disabled
                  />
                </span>
                <CopyTextButton text="https://www.quantman.trade/auth/hdfcsky/callback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Description:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="Quantman" />
              </div>
            </div>
          </div>
        </div>
        <img src="/landing-page-img/brokers-img/hdfcsky_step_3.png" alt="Quantman App details" />
      </li>

      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Now, you can Copy and paste api details in appropriate fields below.
          </h2>
          <img src="/landing-page-img/brokers-img/hdfcsky_step_4.png" alt="Hdfcsky Api credentials" />
        </div>
      </li>

      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Once api activated, Click the back button and fill the API credentials in the required field
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="IIFL fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default Hdfcsky;
